import { render, staticRenderFns } from "./OwnersStaffContacCreate.vue?vue&type=template&id=90f61aba&scoped=true&"
import script from "./OwnersStaffContacCreate.vue?vue&type=script&lang=js&"
export * from "./OwnersStaffContacCreate.vue?vue&type=script&lang=js&"
import style0 from "./OwnersStaffContacCreate.vue?vue&type=style&index=0&id=90f61aba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f61aba",
  null
  
)

export default component.exports